export const SessionStorageKeys = {
  ID_TOKEN: 'idToken',
  USER: 'authUser'
} as const;

export const setSessionItem = <T>(key: string, value: T): void => {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`[sessionStorage] set failed for key "${key}"`, error);
  }
};

export const getSessionItem = <T>(key: string): T | null => {
  try {
    const item = sessionStorage.getItem(key);
    if (!item) return null;
    return JSON.parse(item) as T;
  } catch (error) {
    console.error(`[sessionStorage] get failed for key "${key}"`, error);
    return null;
  }
};

export const removeSessionItem = (key: string): void => {
  sessionStorage.removeItem(key);
};

export const clearSessionStorage = (): void => {
  sessionStorage.clear();
};
